import _styled from "styled-components";
import { useEffect, useState } from 'react';
import Title from '../title';
import { ArrowLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { animated, useTransition } from '@react-spring/web';
import { useMobileNavbarCrossingAnimation } from '../../ui-blocks/navigation-bar/hooks/use-navbar-crossing-animation';
import { Button } from '../button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileTabs = function MobileTabs(_ref) {
  var tabs = _ref.tabs,
      onTabChange = _ref.onTabChange,
      defaultTab = _ref.defaultTab;

  var _useState = useState(undefined),
      activeTab = _useState[0],
      setActiveTab = _useState[1];

  var _useState2 = useState(false),
      overlayVisible = _useState2[0],
      setOverlayVisible = _useState2[1];

  var _useMobileNavbarCross = useMobileNavbarCrossingAnimation(),
      hasCrossedNavbar = _useMobileNavbarCross.hasCrossedNavbar;

  useEffect(function () {
    if (overlayVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return function () {
      document.body.style.overflow = 'auto';
    };
  }, [overlayVisible]);
  useEffect(function () {
    if (defaultTab !== undefined) {
      setActiveTab(defaultTab);
      setOverlayVisible(true);
      onTabChange && onTabChange(defaultTab);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [defaultTab]);

  var showOverlay = function showOverlay(tabIndex) {
    setActiveTab(tabIndex);
    setOverlayVisible(true);
    onTabChange && onTabChange(tabIndex);
  };

  var hideOverlay = function hideOverlay() {
    setOverlayVisible(false);
    setActiveTab(undefined);
    onTabChange && onTabChange(undefined);
  };

  var navOverlayTransitions = useTransition(overlayVisible, {
    from: {
      transform: 'translateX(80%)'
    },
    enter: {
      transform: 'translateX(0%)',
      delay: 100
    },
    leave: {
      transform: 'translateX(100%)',
      delay: 300
    }
  });
  var currentTab = activeTab !== undefined ? tabs[activeTab] : undefined;
  return /*#__PURE__*/_jsxs(Wrapper, {
    children: [tabs.map(function (_ref2, index) {
      var label = _ref2.label,
          badgeContent = _ref2.badgeContent;
      return /*#__PURE__*/_jsxs(TabWrapper, {
        hasBorderBottom: index !== tabs.length - 1,
        onClick: function onClick() {
          return showOverlay(index);
        },
        children: [/*#__PURE__*/_jsxs(TitleWrapper, {
          children: [/*#__PURE__*/_jsx(Title, {
            variant: "h6-large",
            textColor: "black",
            children: label
          }), badgeContent && /*#__PURE__*/_jsx(BadgeContainer, {
            children: /*#__PURE__*/_jsx("span", {
              children: badgeContent
            })
          })]
        }), /*#__PURE__*/_jsx(ArrowContainer, {
          children: /*#__PURE__*/_jsx(_StyledChevronRightIcon, {})
        })]
      }, index);
    }), currentTab && navOverlayTransitions(function (style, item) {
      return item ? /*#__PURE__*/_jsxs(StyledNavOverlay, {
        hasScrolled: hasCrossedNavbar,
        style: style,
        children: [/*#__PURE__*/_jsxs(OverlayTitleWrapper, {
          children: [/*#__PURE__*/_jsx(Button, {
            variant: "white-ghost",
            twStyle: {
              "padding": "0px",
              ":hover": {
                "cursor": "pointer"
              },
              ":focus": {
                "backgroundImage": "none",
                "--tw-ring-offset-shadow": "var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color)",
                "--tw-ring-shadow": "var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color)",
                "boxShadow": "var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000)"
              }
            },
            onClick: hideOverlay,
            children: /*#__PURE__*/_jsx(_StyledArrowLeftIcon, {})
          }), /*#__PURE__*/_jsx(Title, {
            variant: "h6-large",
            textColor: "gray-900",
            fontWeight: "semibold",
            children: currentTab.title
          })]
        }), /*#__PURE__*/_jsx(OverlayBody, {
          children: currentTab.content
        })]
      }) : null;
    })]
  });
};

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__Wrapper",
  componentId: "sc-1udfy0i-0"
})(function () {
  return [{
    "display": "flex",
    "width": "100%",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "0.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});

var TabWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__TabWrapper",
  componentId: "sc-1udfy0i-1"
})(function (_ref3) {
  var hasBorderBottom = _ref3.hasBorderBottom;
  return [{
    "display": "flex",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingBottom": "0.75rem",
    ":hover": {
      "cursor": "pointer"
    },
    ":focus": {
      "cursor": "pointer"
    }
  }, hasBorderBottom ? {
    "borderBottomWidth": "1px",
    "--tw-border-opacity": "1",
    "borderColor": "rgb(209 213 219 / var(--tw-border-opacity))"
  } : {}];
});

var ArrowContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__ArrowContainer",
  componentId: "sc-1udfy0i-2"
})(function () {
  return [{
    "display": "flex",
    "height": "34px",
    "width": "34px",
    "minWidth": "34px",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "9999px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))"
  }];
});

var StyledNavOverlay = /*#__PURE__*/_styled(animated.div).withConfig({
  displayName: "mobile-tabs__StyledNavOverlay",
  componentId: "sc-1udfy0i-3"
})(function (_ref4) {
  var hasScrolled = _ref4.hasScrolled;
  return [{
    "position": "fixed",
    "top": "88px",
    "right": "0px",
    "bottom": "0px",
    "left": "0px",
    "zIndex": "20",
    "boxSizing": "border-box",
    "display": "flex",
    "height": "calc(100vh - 88px)",
    "maxHeight": "calc(100vh - 88px)",
    "maxWidth": "100vw",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "overflow": "hidden",
    "borderTopLeftRadius": "1.563rem",
    "borderTopRightRadius": "1.563rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
  }, hasScrolled && {
    "top": "88px",
    "height": "calc(100vh - 88px)",
    "maxHeight": "calc(100vh - 88px)"
  }];
});

var OverlayTitleWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__OverlayTitleWrapper",
  componentId: "sc-1udfy0i-4"
})(function () {
  return [{
    "position": "sticky",
    "top": "0px",
    "zIndex": "10",
    "display": "flex",
    "height": "5rem",
    "minHeight": "80px",
    "width": "100%",
    "flexDirection": "row",
    "alignItems": "center",
    "gap": "110px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem"
  }];
});

var OverlayBody = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__OverlayBody",
  componentId: "sc-1udfy0i-5"
})(function () {
  return [{
    "display": "flex",
    "height": "100%",
    "maxHeight": "100%",
    "width": "100%",
    "flexDirection": "column",
    "overflowY": "scroll",
    "paddingLeft": "1.5rem",
    "paddingRight": "1.5rem"
  }];
});

var TitleWrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__TitleWrapper",
  componentId: "sc-1udfy0i-6"
})(function () {
  return [{
    "display": "flex",
    "width": "fit-content",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "gap": "0.625rem"
  }];
});

export var BadgeContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "mobile-tabs__BadgeContainer",
  componentId: "sc-1udfy0i-7"
})(function () {
  return [{
    "display": "flex",
    "height": "18px",
    "minHeight": "18px",
    "width": "1.25rem",
    "minWidth": "20px",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "9999px",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(105 62 181 / var(--tw-bg-opacity))",
    "fontSize": "0.75rem",
    "lineHeight": "1rem",
    "fontWeight": "600",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))"
  }];
});

var _StyledChevronRightIcon = /*#__PURE__*/_styled(ChevronRightIcon).withConfig({
  displayName: "mobile-tabs___StyledChevronRightIcon",
  componentId: "sc-1udfy0i-8"
})({
  "height": "18px",
  "width": "18px",
  "--tw-text-opacity": "1",
  "color": "rgb(73 41 131 / var(--tw-text-opacity))"
});

var _StyledArrowLeftIcon = /*#__PURE__*/_styled(ArrowLeftIcon).withConfig({
  displayName: "mobile-tabs___StyledArrowLeftIcon",
  componentId: "sc-1udfy0i-9"
})({
  "height": "1.5rem",
  "width": "1.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(28 19 39 / var(--tw-text-opacity))"
});